<script>
  import { onMount } from "svelte";
  import { Badge } from "sveltestrap";
  import { userPlus } from "svelte-awesome/icons";
  import Icon from "svelte-awesome";
  import DeleteContactModal from "../DeleteContactModal.svelte";
  import axios from "axios";
  export let fullname;
  export let resourceId;
  export let deliverableId;
  export let resourceType;
  let openDeleteContact = false;
  let toggleDeleteContact = () => (openDeleteContact = !openDeleteContact);
  let removeContact_name;
  function handleRemoveContact(name) {
    removeContact_name = name;
    toggleDeleteContact();
  }
</script>

<style>

</style>

<Badge style="margin: 8px; padding-right: 4px;" pill>
  {fullname}
  <button
    style="border: none; background-color: white; border-radius: 50%;"
    on:click={handleRemoveContact(fullname)}>
    X
  </button>
</Badge>

{#if removeContact_name != null}
  <DeleteContactModal
    open={openDeleteContact}
    toggle={toggleDeleteContact}
    name={removeContact_name}
    {resourceId}
    {deliverableId}
    {resourceType}
    on:resourceUnassigned />
{/if}
